/**
 * [description]
 * @param  {String|Number} price
 * @return {String}        converted currency (if converter available)
 */
const formatPrice = (price) => `$${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const getCurrency = (price) => {
    const getCurrencyString = typeof ft !== 'undefined' ? ft.utl.getCurrencyString : formatPrice; // eslint-disable-line no-undef

    return typeof price === 'number' || typeof price === 'string' ?
        getCurrencyString(price, true, true, true) : '';
};




// WEBPACK FOOTER //
// ./src/utils/getCurrency/index.js